import { render, staticRenderFns } from "./ApplicantSkillsForm.vue?vue&type=template&id=12fc539d&scoped=true"
import script from "./ApplicantSkillsForm.vue?vue&type=script&lang=js"
export * from "./ApplicantSkillsForm.vue?vue&type=script&lang=js"
import style0 from "./ApplicantSkillsForm.vue?vue&type=style&index=0&id=12fc539d&prod&lang=css"
import style1 from "./ApplicantSkillsForm.vue?vue&type=style&index=1&id=12fc539d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc539d",
  null
  
)

export default component.exports